// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zJlN","inner":"Footer_inner__Pbtsu"};